import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const missingKey =
  typeof firebaseConfig.apiKey !== 'string' || !firebaseConfig.apiKey.trim();

if (missingKey) {
  throw new Error(
    '[Firebase] Missing VITE_FIREBASE_API_KEY. For `pnpm prod` / `vite --mode production`, ensure `apps/web/.env.production` (or `.env.production.local`) defines it. For day-to-day local work, use `pnpm dev` which loads `.env.development`.',
  );
}

const projectId = String(firebaseConfig.projectId ?? '').trim();
if (import.meta.env.DEV && projectId === 'speedymovinginventory') {
  // Warn only: some teams intentionally point `pnpm dev` at prod Firebase (e.g. `.env.development.local`).
  // A throw here blanked the whole app with no UI recovery.
  console.warn(
    '[Firebase] Vite dev mode is using the PRODUCTION project (`speedymovinginventory`). ' +
      'Password reset and Auth traffic go to prod. For emulator/dev-only data use `speedymovinginventorydev-9c905` in `.env.development`. See `apps/web/.env.local.example`.',
  );
}

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);

if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectDatabaseEmulator(db, 'localhost', 9000);
  connectStorageEmulator(storage, 'localhost', 9199);
}

export { app };
